import { Flex, Typography } from "antd";

import { ImageRowList } from "@/shared/ui/ImageRowList";
import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";

type AssignmentTaskInfoProps = {
    assignmentType: string;
    description?: string | null;
    images?: string[];
};

export const AssignmentTaskInfo = ({
    assignmentType,
    description,
    images = [],
}: AssignmentTaskInfoProps) => {
    const hasFiles = images.length > 0;

    return (
        <Flex vertical gap={8}>
            <Flex vertical gap={8}>
                <Flex gap={4}>
                    <SecondaryText>Тип доручення:</SecondaryText>
                    <PrimaryText>{assignmentType}</PrimaryText>
                </Flex>

                {!!description && (
                    <Typography
                        dangerouslySetInnerHTML={{
                            __html: description,
                        }}
                    />
                )}
            </Flex>

            {hasFiles && <ImageRowList images={images} />}
        </Flex>
    );
};
